import { AnimatePresence, motion } from 'framer-motion'
import React, { FC, ReactNode } from 'react'

import Badge from '@/modules/components/Badge'
import Box, { BoxProps } from '@/modules/components/Box'
import Button from '@/modules/components/Button'
import Flex from '@/modules/components/Flex'
import Icon from '@/modules/components/Icon'
import Typography from '@/modules/components/Typography'

interface MobileMenuItemProps extends BoxProps {
  title: string
  badgeTitle?: string
  content?: ReactNode
  isExpanded?: boolean
  onClick?: () => void
}

const MobileMenuItem: FC<MobileMenuItemProps> = ({
  title,
  badgeTitle,
  content,
  isExpanded = false,
  onClick,
  ...props
}) => {
  const IconComponent = isExpanded ? Icon.ChevronUp : Icon.ChevronDown

  return (
    <Box {...props}>
      <Button width="100%" variant="navMenu" onClick={onClick} height="56px">
        <Flex alignItems="center" justifyContent="space-between">
          <Flex alignItems="center">
            <Typography
              variant="menuTitle"
              color="primaryDeepBlack"
              leadingTrim
            >
              {title}
            </Typography>
            {badgeTitle && (
              <Badge variant="light" ml={1}>
                {badgeTitle}
              </Badge>
            )}
          </Flex>
          {onClick && (
            <IconComponent fontSize="12px" color="secondaryDarkNavy" />
          )}
        </Flex>
      </Button>
      <AnimatePresence>
        {isExpanded && (
          <motion.section
            initial="collapsed"
            animate="open"
            exit={'collapsed'}
            variants={{
              open: { opacity: 1, height: 'auto' },
              collapsed: { opacity: 0, height: 0 },
            }}
            transition={{ duration: 0.3, ease: [0.04, 0.62, 0.23, 0.98] }}
          >
            {content}
          </motion.section>
        )}
      </AnimatePresence>
    </Box>
  )
}

export default MobileMenuItem
